// element-ui 组件库
import ElementUI from 'element-ui'
import '@/assets/style/element/variables.scss'
// vue-particles 粒子特效
import VueParticles from 'vue-particles'
// vue-print-nb 打印
import Print from 'vue-print-nb'
// v-charts 图表
import VCharts from 'v-charts'
// v-viewer 图片查看器
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// vue-video-player 视频播放器
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
// dayjs 时间处理
import dayjs from 'dayjs'
// 常量key
import key from '@/key'
// 工具函数
import util from '@/utils/util'
//自定义组件
import '@/components/index'

export default {
  async install(Vue) {
    Vue.config.productionTip = false
    Vue.use(ElementUI)
    Vue.use(VueParticles)
    Vue.use(Print)
    Vue.use(VCharts)
    Vue.use(VueViewer)
    Vue.use(VueVideoPlayer)
    Vue.prototype.$dayjs = dayjs
    Vue.prototype.$key = key
    Vue.prototype.$util = util
  }
}
